import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ScrollPagination from "../../../../../common/ScrollPagination";
import UserService from "../../../../../../services/UserService";
import { Translate } from "../../../../../Enums/Tranlate";

const PlayersModal = ({ modal, item, setModal, submitFu, text }) => {
	const [formData, setFormData] = useState([]);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (text === "add") {
			setFormData(item?.add_player);
		} else if (text === "invite") {
			setFormData(item?.invite_player);
		} else {
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();
		submitFu(formData);
		setModal();
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{Translate[lang][text]} {Translate[lang]?.players}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						<Col md={12}>
							<label className="text-label">{Translate[lang]?.players}</label>
							<ScrollPagination
								Service={new UserService()}
								value={formData}
								nameVal={"fullname"}
								isMulti={true}
								setData={(e) => setFormData(e)}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" type="submit" className="w-100">
						{Translate[lang][text]} {Translate[lang]?.players}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default PlayersModal;
